// Tenantra Inc. - Collection curve: % of the month's rent collected by each day, this month vs last month
import { CartesianGrid, Legend, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Card, pct } from './kit';

export function CollectionCurve({ curve }) {
  const { this: cur, last, day, this_pct: a, last_pct: b, tenantra_only: partial } = curve;
  const data = Array.from({ length: 31 }, (_, i) => ({ day: i + 1, cur: cur.points[i], last: last.points[i] }));
  const diff = a != null && b != null ? Math.round((a - b) * 10) / 10 : null;
  return (
    <Card title="Collection curve" aside={`${cur.label} vs ${last.label}`} testId="collection-curve">
      <div className="px-5">
        <p className="text-sm text-slate-700" data-testid="collection-curve-headline">
          By day {day}: <span className="font-medium text-slate-900">{pct(a)}</span> collected
          {b != null && <> vs <span className="font-medium">{pct(b)}</span> last month</>}
          {diff != null && diff !== 0 && <span className={`ml-1.5 text-xs whitespace-nowrap ${diff > 0 ? 'text-emerald-700' : 'text-red-700'}`}>{diff > 0 ? '+' : ''}{diff} pts</span>}
        </p>
      </div>
      <div className="px-2 pb-2 pt-1">
        <ResponsiveContainer width="100%" height={190}>
          <LineChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
            <XAxis dataKey="day" tick={{ fontSize: 10, fill: '#94a3b8' }} axisLine={false} tickLine={false} interval={4} />
            <YAxis domain={[0, 100]} tick={{ fontSize: 10, fill: '#94a3b8' }} axisLine={false} tickLine={false} width={32} tickFormatter={(v) => `${v}%`} />
            <Tooltip contentStyle={{ fontSize: 12, borderRadius: 6, border: 'none', boxShadow: '0 4px 14px rgba(15,23,42,0.10)' }} labelFormatter={(d) => `Day ${d}`} formatter={(v, n) => [pct(v), n]} />
            <Legend iconType="plainline" iconSize={12} wrapperStyle={{ fontSize: 11 }} />
            <ReferenceLine x={day} stroke="#cbd5e1" strokeDasharray="2 3" />
            <Line type="stepAfter" dataKey="last" name={last.label} stroke="#94a3b8" strokeDasharray="4 3" strokeWidth={1.5} dot={false} connectNulls={false} />
            <Line type="stepAfter" dataKey="cur" name={cur.label} stroke="#0f766e" strokeWidth={2} dot={false} connectNulls={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      {partial && <p className="px-5 pb-3 text-[11px] text-slate-400" data-testid="collection-curve-note">This month only counts rent paid through Tenantra so far. Rent you collect yourself is added when you file the monthly report.</p>}
    </Card>
  );
}
